import { gsap } from 'gsap';
import { CustomEase } from 'gsap/CustomEase';

import * as FadeIn from './FadeIn.js';
import * as ToggleStickyMenu from './ToggleStickyMenu.js';

gsap.registerPlugin(CustomEase);

const init = () => {
  const splashElm = document.querySelector('.js-splash');
  if(!splashElm) return;

  const headingElm = splashElm.querySelector('.js-splashHeading');
  const infoElm = splashElm.querySelector('.js-splashInfo');
  const venuePersonsElm = splashElm.querySelector('.js-splashVenuePersons');
  const venueBodyElm = splashElm.querySelector('.js-splashVenueBody');
  const bgElms = splashElm.querySelectorAll('.js-splashBg [data-order]');
  const bgFirstElms = splashElm.querySelectorAll('.js-splashBg [data-order="1"]');
  const bgSecondElms = splashElm.querySelectorAll('.js-splashBg [data-order="2"]');
  const bgThirdElms = splashElm.querySelectorAll('.js-splashBg [data-order="3"]');
  const splashSideKv = document.querySelector('.js-splashSideKv');
  const splashSideNav = document.querySelector('.js-splashSideNav');

  CustomEase.create('Smooth', '0.47, 0, 0.23, 1.38');
  CustomEase.create('Slow', '0.25, 0.1, 0.25, 1');
  CustomEase.create('SlowSecondary', 'M0,0 C0.19,0.06 0.28,0.88 1,1');

  let hasPlayed = false;

  const tl = gsap.timeline({
    delay: 0.3,
    onStart: () => {
      hasPlayed = sessionStorage.getItem('splashPlayed');
      hasPlayed = false;
      if (hasPlayed) {
        tl.progress(1);
        gsap.set([venuePersonsElm, venueBodyElm], { opacity: 1, y: 0 });
        splashElm.classList.add('is-loaded');
        FadeIn.init();
        ToggleStickyMenu.init();
        tl.kill();
      } else {
        sessionStorage.setItem('splashPlayed', 'true');
      }
    },
    onComplete: () => {
      splashElm.classList.add('is-loaded');
      FadeIn.init();
      ToggleStickyMenu.init();
    }
  });

  const mm = gsap.matchMedia();

  tl.to(bgElms, { opacity: 1, scale: 1, duration: 0.5, stagger: { each: 0.1, from: 'random' }, ease: 'Smooth' }, '+=0.1')
    .to(headingElm, { clipPath: 'inset(0 0% 0 0)', duration: 0.6, ease: 'Slow' }, '+=0.3')
    .to(infoElm, { clipPath: 'inset(0 0% 0 0)', duration: 0.3, ease: 'SlowSlowSecondary' }, '-=0.2')
    .to([venuePersonsElm, venueBodyElm], { opacity: 1, y: 0, duration: 0.3, ease: 'Slow' });
    mm.add('(min-width: 768px)', () => {
      tl.to(splashSideNav, { opacity: 1, duration: 0.8, ease: 'Smooth' }, '-=0.5');
    });
    mm.add('(min-width: 992px)', () => {
      tl.to(splashSideKv, { opacity: 1, scale: 1, rotate: 0, duration: 0.8, ease: 'Smooth' }, '-=0.8');
    });
}

export {
  init
}